<template>
  <div class="images">
    <!-- Titel -->
    <div>
      <h1>Images</h1>

      <!-- Button Add image  -->
      <button
        v-if="!addImage"
        class="btn btn-outline-secondary mb-3 float-end new-image"
        @click="addImage = !addImage"
      >
        <i class="bi bi-plus-lg"></i>
        Add image
      </button>
    </div>

    <!-- Add image component -->
    <div v-if="addImage">
      <!-- Description -->
      <small class="text-secondary"
        >Add image from URL, File or generate new image.</small
      >

      <ImageAdd
        class="mt-3 mb-3"
        :imageUrl="imageUrl"
        :styles="styles"
        @close="addImage = false"
      />
    </div>

    <!-- Images list -->
    <div v-else>
      <!-- Description -->
      <small class="text-secondary">This is a list of available images.</small>

      <!-- Filter -->
      <div class="input-group mt-3 mb-3">
        <!-- Filter text -->
        <input
          class="form-control"
          v-model="imagesFilter.filter"
          placeholder="Enter filter text"
        />

        <!-- OR or END button -->
        <button
          type="button"
          class="btn bg-transparent operation"
          :operation="imagesFilter.operation"
          @click="
            imagesFilter.operation == 'or'
              ? (imagesFilter.operation = 'and')
              : (imagesFilter.operation = 'or')
          "
        >
          {{ imagesFilter.operation.toUpperCase() }}
        </button>

        <!-- Clear filter button -->
        <button
          type="button"
          class="btn bg-transparent clear"
          @click="clearFilter"
        >
          <i class="fa fa-times"></i>x
        </button>

        <!-- Filter  button -->
        <button type="button" class="btn btn-primary" @click="changefilterType">
          {{ imagesFilter.typeBtnName }}
        </button>
      </div>

      <!-- List images -->
      <div v-for="(image, index) in images" :key="index">
        <div v-if="checkFilters(image)">
          <ImageCard
            :image="image"
            :index="index"
            :imageUrl="imageUrl"
            :displayStyles="displayStyles"
            @imageLoaded="image.loaded = true"
          />
        </div>
      </div>

      <!-- Loading indicator -->
      <div class="d-flex justify-content-center m-4" style="height: 32px">
        <div
          v-if="processGetPage && showLoader"
          class="spinner-border text-secondary"
          role="status"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- Next page button -->
      <!-- <div v-if="!processGetPage && previous && !error" class="text-center">
      <a
        class="btn btn-secondary"
        :class="processGetPage ? 'disabled' : ''"
        @click="getNextPage()"
      >
        <i v-if="!processGetPage" class="bi bi-box-arrow-down"></i>
        <i v-else class="bi bi-arrow-clockwise"></i>
      </a>
    </div> -->
    </div>

    <!-- Go to top button -->
    <GoTop />
  </div>
</template>

<script>
import GoTop from "../GoTop.vue";
import ImageAdd from "../ImageAdd.vue";
import ImageCard from "../ImageCard.vue";

const cmdImages = "images.list/";
const cmdImageUrl = "images.url";

export default {
  name: "PageImages",

  components: {
    ImageCard,
    ImageAdd,
    GoTop,
  },

  data() {
    return {
      images: [],
      addImage: false,
      imageUrl: "http://localhost:8086",

      processGetPage: true,
      showLoader: false,
      previous: "",
      error: "",

      imagesFilterTypes: ["All", "Tags", "Names", "Styles", "Prompts"],
      imagesFilter: {
        filter: "",
        operation: "or",
        typeBtnName: "Tags",
      },

      styles: [
        { id: 0, name: "no style" },
        { id: 1, name: "random" },
        { id: 2, name: "niji" },
        { id: 3, name: "steampunk" },
        { id: 4, name: "cyberpunk" },
        { id: 5, name: "anime" },
        { id: 6, name: "logo" },
        { id: 7, name: "photo" },
        { id: 8, name: "image" },
        { id: 9, name: "cinema" },
        { id: 10, name: "illustration" },
        { id: 11, name: "horror" },
        { id: 12, name: "detailed" },
        { id: 13, name: "space" },
        { id: 14, name: "gothic" },
        { id: 15, name: "surrealism" },
        { id: 16, name: "realism" },
        { id: 17, name: "fantasy" },
        { id: 18, name: "scifi" },
        { id: 19, name: "fantasy art" },
        { id: 20, name: "comicbook" },
        { id: 21, name: "pixelart" },
        { id: 22, name: "3d" },
        { id: 23, name: "lineart" },
        { id: 24, name: "origami" },
        { id: 25, name: "isometric" },
        { id: 26, name: "neonpunk" },
        { id: 27, name: "primeanime" },
        { id: 28, name: "watercolor" },
        { id: 29, name: "popart" },
        { id: 30, name: "kawaii" },
        { id: 31, name: "minimalism" },
        { id: 32, name: "retrofutur" },
        { id: 33, name: "dystopian" },
        { id: 34, name: "advertising" },
        { id: 35, name: "renaissance" },
        { id: 36, name: "biomechanical" },
        { id: 37, name: "futuristic" },
        { id: 38, name: "artdeco" },
        { id: 39, name: "cubism" },
        { id: 40, name: "fashion" },
        { id: 41, name: "rpg" },
        { id: 42, name: "disco" },
        { id: 43, name: "architecture" },
        { id: 44, name: "luxury" },
        { id: 45, name: "cybernetic" },
        { id: 46, name: "retrocyber" },
        { id: 47, name: "biocyber" },
        { id: 48, name: "fairytale" },
        { id: 49, name: "pinup" },
      ],
    };
  },

  mounted() {
    // Set scroll listener
    window.addEventListener("scroll", this.scrollListener);

    // Get filters from localstorage
    const imagesFilter = localStorage.getItem("imagesFilter");
    if (imagesFilter) {
      Object.assign(this.imagesFilter, JSON.parse(imagesFilter));
    }

    // Get image url
    this.getImageUrl();

    // Get first images list page
    this.getNextPage(true);
  },

  unmounted() {
    window.removeEventListener("scroll", this.scrollListener);
  },

  watch: {
    "imagesFilter.filter"() {
      this.filterUpdated();
    },
    "imagesFilter.typeBtnName"() {
      this.filterUpdated();
    },
    "imagesFilter.operation"() {
      this.filterSave();
    },
  },

  methods: {
    /**
     * Save filter set to local storage
     */
    filterSave() {
      // Save filter to local storage
      localStorage.setItem("imagesFilter", JSON.stringify(this.imagesFilter));
    },

    /**
     * Filter updated. Save filter to local storage and check if page need to be reloaded.
     * If filter is empty and previous is empty (all images loaded), reload page.
     * If filter is changed and previous is not empty (not all images loaded), get next page.
     */
    filterUpdated() {
      this.filterSave();

      // Skip page if it is loading
      if (this.processGetPage) {
        return;
      }

      // Reload page if filter is empty and previous is empty (all images loaded)
      if (!this.imagesFilter.filter && !this.previous) {
        this.getNextPage(true);
        return;
      }

      // Get next page if filter is changed and previous is not empty (not all images loaded)
      if (this.previous) {
        this.getNextPage();
        return;
      }
    },

    /**
     * Get next page of images. If reload is true, it will remove all images and start from the first page.
     * @param {boolean} reload - Reload from the first page
     */
    getNextPage(reload = false) {
      // If reload is true, remove all images and set previous to empty string
      if (reload) {
        this.images = [];
        this.previous = "";
      }

      // Show loader after 250ms
      this.processGetPage = true;
      setTimeout(() => {
        if (this.processGetPage) this.showLoader = true;
      }, 250);

      // Set max keys to 10. If filter is set, set max keys to 50.
      let maxKeys = 10;
      if (this.imagesFilter.filter) {
        maxKeys = 50;
      }

      // Send cmdImages command with parameter sub to WebRTC server
      this.sendCmd(cmdImages + this.previous + "/" + maxKeys).then(
        // Process success answer
        (data) => {
          this.webasmReady.then(() => {
            // Decompress data
            data = window.decompressData(data);

            // Parse data to JSON
            const list = JSON.parse(data);

            // If list has images, add them to the images array
            if (list.Images) {
              this.images = this.images.concat(list.Images);
            }

            // Set previous to the pagination token
            this.previous = list.Pagination;

            // If filter is set, get next page while there are less than 10 images
            if (this.imagesFilter.filter && list.Pagination) {
              if (this.imagesLength() <= 10) {
                this.getNextPage();
                return;
              }
            }

            // Stop loader
            this.processGetPage = false;
            this.showLoader = false;
          });
        },
        // Process an error
        (err) => console.error("cmdImages error:", err)
      );
    },

    /**
     * Get the length of the images array, filtered by the filter if it is set.
     * @returns {number} - The length of the images array.
     */
    imagesLength() {
      // If the filter is set, filter the images array
      if (this.imagesFilter.filter) {
        return this.images.filter((item) => {
          // Check if the tag is in the filter
          return item.tags.includes(this.imagesFilter.filter);
        }).length;
      } else {
        // If the filter is not set, return the length of the images array
        return this.images.length;
      }
    },

    /**
     * Get the URL of the image server.
     * The URL is used to construct the URLs of the images.
     */
    getImageUrl() {
      this.sendCmd(cmdImageUrl).then(
        // Process success answer
        (data) => {
          // Set the image URL
          this.imageUrl = data;
          return;
        },
        // Process an error
        (err) => console.error("cmdImageUrl error:", err)
      );
    },

    /**
     * The scroll listener function. It is called when the user scrolls.
     * If the user has scrolled to the bottom of the page, it calls getNextPage.
     */
    scrollListener() {
      // The current scroll position
      const scrollTop = window.scrollY;

      // The height of the document
      const scrollHeight = document.body.scrollHeight;

      // The height of the viewport
      const clientHeight = window.innerHeight;

      // If the user has scrolled to the bottom of the page
      if (scrollTop + clientHeight + 2500 >= scrollHeight) {
        // If there are more images and the loading process is not running
        if (this.previous && !this.error && !this.processGetPage) {
          // Call getNextPage
          this.getNextPage();
        }
      }
    },

    /**
     * Returns a string representation of the styles array.
     * @param {number[]} styles - The array of style indices.
     * @returns {string} - A string representation of the styles array.
     */
    displayStyles(styles) {
      let stylesStr = "";
      // Iterate over the styles array
      for (var i = 0; styles && i < styles.length; i++) {
        // If it is not the first element, add a comma and a space
        if (i > 0) stylesStr += ", ";
        // Add the style id and name to the string
        stylesStr +=
          this.styles[styles[i]].id + " => " + this.styles[styles[i]].name;
      }
      // Return the string representation of the styles array
      return stylesStr;
    },

    /**
     * Changes the type of filter.
     * Gets the index of the current type of filter from the imagesFilterTypes array.
     * If the index is -1 or it is the last item in the array, sets the type of filter to the first item.
     * Otherwise, sets the type of filter to the next item in the array.
     */
    changefilterType() {
      // Get index of typeBtnName in itemTypes
      const index = this.imagesFilterTypes.indexOf(
        this.imagesFilter.typeBtnName
      );
      if (index == -1 || index == this.imagesFilterTypes.length - 1) {
        // If index is -1 or it is the last item in array, go back to the first item
        this.imagesFilter.typeBtnName = this.imagesFilterTypes[0];
        return;
      }
      // Change filterTypeBtnName to the next item in array
      this.imagesFilter.typeBtnName = this.imagesFilterTypes[index + 1];
    },

    /**
     * Clears the filter text.
     */
    clearFilter() {
      // Clear the filter text
      this.imagesFilter.filter = "";
    },

    /**
     * Check if image name or tags match filter words
     * @param {Object} image - image object
     * @returns {boolean} - true if image match filter
     */
    checkFilters(image) {
      // Empty filter show all images
      if (this.imagesFilter.filter == "") {
        return true;
      }

      // Split this.imagesFilter.filter to array by words and remove empty words
      const words = this.imagesFilter.filter
        .split(" ")
        .filter((word) => word != "")
        .map((word) => word.toLowerCase().trim());

      /**
       * Check if where contains filter words
       * @param {string} where - string to check
       * @param {string} orAnd - "or" or "and"
       * @returns {boolean} - true if filter contains part of where
       */
      const checkWords = (where, orAnd = "or") => {
        if (orAnd === "or") {
          return words.some((word) => where.includes(word));
        }
        return words.every((word) => where.includes(word));
      };

      const that = this;

      const getWhere = (type) => {
        let ret = "";

        switch (type) {
          case "Tags":
            ret = image.tags;
            break;

          case "Names":
            ret = image.name;
            break;

          case "Styles":
            ret = that.displayStyles(image.styles);
            break;

          case "Prompts":
            ret = image.prompt;
            break;

          default:
            ret = "";
            break;
        }

        return ret.toLowerCase();
      };

      const types = this.imagesFilterTypes.slice(1);

      // Check filter in OR operation mode
      if (this.imagesFilter.operation == "or") {
        return types.some((type) => {
          return (
            (this.imagesFilter.typeBtnName == "All" ||
              this.imagesFilter.typeBtnName == type) &&
            checkWords(getWhere(type), this.imagesFilter.operation)
          );
        });
      }

      // Check filter in AND operation mode whith all types
      if (this.imagesFilter.typeBtnName != "All") {
        return checkWords(
          getWhere(this.imagesFilter.typeBtnName),
          this.imagesFilter.operation
        );
      }

      // Check filter in AND operation mode whith selected type
      return words.every((word) => {
        return types.some((type) => {
          return getWhere(type).includes(word);
        });
      });
    },
  },
};
</script>

<style scoped>
.images {
  width: 640px;
  max-width: 100%;
}
.new-image {
  margin-top: -2.2rem;
}

.input-group > button.operation {
  font-size: small;
  opacity: 0.5;
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 0;
  z-index: 100;
}
.input-group > button.operation[operation="or"] {
  margin-left: -80px !important;
}
.input-group > button.operation[operation="and"] {
  margin-left: -92px !important;
}
.input-group > button.operation:hover {
  opacity: 1;
}

.input-group > button.clear {
  opacity: 0.5;
  margin-left: 0;
  padding-top: 4px;
  margin-top: 5px;
  margin-bottom: 5px;
  z-index: 100;
}
.input-group > button.clear:hover {
  opacity: 1;
}

.input-group > input {
  margin-right: 29px;
}
</style>
